import { createSlice } from '@reduxjs/toolkit';

import { handleGetSupplementResponseStatuses } from './actions';
import { ISupplementResponseStatusesState } from './slice.interface';

const initialState: ISupplementResponseStatusesState = {
  data: [],
  isLoading: false,
  isReady: false,
  error: false,
};

export const supplementResponseStatusesSlice = createSlice({
  name: 'supplement-response-statuses',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(
        handleGetSupplementResponseStatuses.pending,
        (state: ISupplementResponseStatusesState) => {
          state.isLoading = true;
          state.error = false;
        },
      )
      .addCase(
        handleGetSupplementResponseStatuses.rejected,
        (state: ISupplementResponseStatusesState) => {
          state.isLoading = false;
          state.error = true;
        },
      )
      .addCase(
        handleGetSupplementResponseStatuses.fulfilled,
        (state: ISupplementResponseStatusesState, action) => {
          state.data = action.payload.data;
          state.isLoading = false;
          state.isReady = true;
        },
      );
  },
});

export default supplementResponseStatusesSlice.reducer;
